module.exports = __webpack_public_path__ + "static/quote-b59ac10cc12aa58817b0cdce03e1dfda.png";